import React from 'react';
import BounceLoader from "react-spinners/BounceLoader"; // react-spinners
import { css } from "@emotion/core";

export const LoadingSpinner = (props: { page?: boolean }) => {
  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

  const style = props.page ? { margin: "10vh 0" } : {}
  return (
    <div id="loading-spinner" style={style}>
      <BounceLoader color={"var(--clickable-color)"} css={override} size={150} />
    </div>
  )
}